<template>
  <div class="l-page">
    <section class="l-section">
      <TutorialAnimation />
    </section>
    <section class="l-section">
      <ChooseSystem
        @onSelectSystem="selectSystem"
        :selectedSystem="selectedSystem"
        :systems="systems"
      />
    </section>

    <section class="l-section">
      <ChooseDriver
        v-if="printers.length > 0"
        :system="selectedSystem"
        :printers="printers"
        :selectedPrinter="selectedPrinter"
        @onSelectPrinter="selectPrinter"
      />
      <div class="l-download-button">
        <button class="c-button" :disabled="!isDataReadyForDownload || loading" @click="downloadApp">Download</button>
        <div v-if="loading" class="c-loader"></div>
        <p class="c-error-msg u-mt-sm" v-if="error"> {{error}} </p>
      </div>
    </section>

    <footer class="l-footer ">meridianbet.rs</footer>
  </div>
</template>

<script>
import { apiService } from '../services/api';
import TutorialAnimation from './Layout/TotorialAnimation';
import ChooseSystem from './ChooseSystem';
import ChooseDriver from './ChooseDriver';
import config from '../../config/local';
import { configService } from '../services/config.service';

export default {
  name: 'HomePage',

  components: {
    ChooseSystem,
    ChooseDriver,
    TutorialAnimation,
  },

  data() {
    return {
      selectedSystem: {},
      selectedPrinter: {},
      printers: [],
      systems: {},
      isDataReadyForDownload: false,
      error: '',
      loading: false,
      updateSystemsItnerval: null
    }
  },

  async created() {
    await this.getApps();
    await this.selectSystem(this.systems[0]);
    this.initUpdateSystemsInterval();
  },

  methods: {
    initUpdateSystemsInterval() {
      this.updateSystemsItnerval = setInterval(async () => {
        this.getApps();
        this.resetSelections();
      }, 60000);
    },

    async getApps() {
      try {
        const { data } = await apiService.get('/app-manager/active-apps');
        this.systems = this.prepareDataForSystems(data);
      } catch(e) {
        this.error = e.error || 'Something went wrong'
      }
    },

    async getPrinters() {
      const { data } = await apiService.get('/app-manager/printers');
      this.printers = data;
    },

    async selectSystem(system) {
      this.selectedSystem = system;
      this.selectedPrinter = {};
      this.isDataReadyForDownload = false;

      await this.getPrinters();

      this.printers = this.printers
        .filter(printer =>
          printer[system.driveLink])
        .map(printer => ({
          name: printer.name,
          driver: printer[system.driveLink],
          script: printer.setupScriptName
        }));
    },

    selectPrinter(selectedPrinter) {
      this.selectedPrinter = selectedPrinter;
      this.isDataReadyForDownload = true;
    },

    prepareDataForSystems(avalablePlatforms) {
      return avalablePlatforms.map(singlePlatform => {
        return {
          ...singlePlatform,
          ...this.getPlatformName(singlePlatform.platform)
        }
      })
    },

    getPlatformName(os) {
      switch(os) {
        case 'mac':
        case 'ios': 
          return {
            platformName: 'Mac',
            iconName: 'appleinc',
            driveLink: 'iOSLink',
          };
        case 'linux':
          return {
            platformName:'Linux',
            iconName: 'tux',
            driveLink: 'linuxLink',
          };
        case 'windows':
          return {
            platformName: 'Windows',
            iconName: 'windows',
            driveLink: 'windowsLink',
          };
      } 
    },

    downloadApp() {
      const link = document.createElement('a');
      link.setAttribute('download', null);
      link.style.display = 'none';
      document.body.appendChild(link);
      this.downloadLink(link, `${config.APP_DOWNLOAD_URL}/${configService.getAppEnv()}/` + this.selectedSystem.name);
      setTimeout(() => {
        if (!this.selectedPrinter.driver) {
          return;
        }
        this.downloadLink(link, this.selectedPrinter.driver);
      }, 500);

      setTimeout(() => {
        if (this.selectedPrinter.script !== null){
          this.downloadLink(link, `${config.APP_MANAGEMENT_API}/download?path=uploads/${this.selectedPrinter.script}`);
        }
        document.body.removeChild(link);
        this.resetSelections();
        clearInterval(this.updateSystemsItnerval);
      }, 1000);
    },

    downloadLink(link, url) {
      link.setAttribute('href', url);
      link.click();
    },

    resetSelections() {
      this.selectedSystem = {};
      this.selectedPrinter = {};
      this.isDataReadyForDownload = false;
    },
  },
};
</script>
